// @ts-nocheck
import React, { useCallback } from 'react';
import { FilterItem } from '../../../../components';
import Field from '../../../../components/card/Field';
import { CommonFilter } from '../../../../components/hoc/common/handbook/CommonFilter';
import { Input } from 'antd';
export const SparePartsFilter = props => {
  const Filter = useCallback(filterProps => CommonFilter({
    ...filterProps,
    ...props
  }), [props]);
  return <Filter>
      {(values, changeValue) => <>
          <FilterItem>
            <Field mBottomNone>
              <Input size="small" placeholder="Темы" value={values.search} onChange={e => changeValue('search', e.target.value)} />
            </Field>
          </FilterItem>
        </>}
    </Filter>;
};
export default SparePartsFilter;
